export function getOrderPrefix(serviceType: string, subService?: string): string {
  const map: Record<string, Record<string, string> | string> = {
    // 商标服务
    trademark: {
      registration: 'TMZC',
      transactions: 'TMJY',
      extension: 'YQ',
      postpone_evidence: 'SOU',
      transfer: 'TMZR',
      review: 'BHFS',
      revocation: 'WYC',
      search: 'TMJS',
      oath: 'TMXS',
      renewal: 'TMXZ',
      agency_transfer: 'TMZDL',
      cancellation: 'TMZC',
      certificate_reissue: 'BZ',
      information_changes: 'TMBG',
      investment: 'TMTZ',
    },
    // 专利服务
    patent: {
      appearance_application: 'WGZL',
      invention_application: 'PTSQ',
      utility_application: 'SYXX',
      authorization: 'PTSQ',
      rejection_review: 'PTFS',
    },
    // 版权服务
    copyright: {
      registration: 'CORTR',
      transfer: 'CORTT',
      // 未提供映射的子业务使用默认
    },
    // 工商服务
    company: {
      registration: 'GSZC',
      annual_review: 'GSNS',
      bank_account_opening: 'GSKH',
      cancellation: 'GSZX',
      information_changes: 'GSBG',
      audit: 'GSSJ',
    },
    // 条形码服务
    barcode: {
      registration: 'TXMZC',
      renewal: 'TXMXF',
      cancellation: 'TXMZX',
      increase: 'TXMXF',
    },
    // 其他服务（任意子业务统一使用 QTFW）
    other: {
      registration: 'QTFW',
      cancellation: 'QTQC'
    },
  };

  const byService = map[serviceType];
  if (!byService) return 'ORD';

  if (typeof byService === 'string') return byService; // 例如 other

  if (subService && byService[subService]) return byService[subService];

  return 'ORD';
}


export function generateOrderNo(): string{
  const timestamp = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}${String(new Date().getDate()).padStart(2, '0')}`;
  const random = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `ORD${timestamp}${random}`;
};

export function generateOrderNoWithPrefix(prefix: string): string {
  const timestamp = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}${String(new Date().getDate()).padStart(2, '0')}`;
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}${timestamp}${random}`;
}

